import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "../../components/BrandMark";

export default function LandingFooter() {
  return (
    <footer className="border-t border-white/10 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
        <BrandMark size={24} textClassName="font-display tracking-wider text-white/70" />
        <div className="flex items-center gap-5">
          <Link
            to="/privacy"
            className="hover:text-white transition-colors"
            data-testid="footer-privacy-link"
          >
            Privacy
          </Link>
          <span>© 2026 DAIONE · Train. Track. Transform.</span>
        </div>
      </div>
    </footer>
  );
}
